import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiJson } from '../api/client.js';
import { MailboxEmailsList } from '../components/MailboxPanels.jsx';
import { MailMessageDialog } from '../components/MailClient.jsx';

export function MyEmailsPage() {
  const [searchParams] = useSearchParams();
  const query = (searchParams.get('q') || '').trim().toLowerCase();
  const [data, setData] = useState(null);
  const [openMailId, setOpenMailId] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiJson('/api/my/emails')
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    if (!data || !query || !data.items) return data;
    return {
      ...data,
      items: data.items.filter((e) =>
        `${e.subject || ''} ${e.from_name || ''} ${e.from_email || ''} ${e.preview || ''}`
          .toLowerCase()
          .includes(query),
      ),
    };
  }, [data, query]);

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Emails</h2>
      <p className="muted small">Messages involving your company email address.</p>
      {error ? <p className="err">{error}</p> : null}
      <MailboxEmailsList data={filtered} loading={loading} onOpen={(email) => setOpenMailId(email.id)} />
      <MailMessageDialog
        apiBase="/api/my/emails"
        messageId={openMailId}
        onClose={() => setOpenMailId(null)}
      />
    </div>
  );
}
